import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../../../../store"

import BookmarkWidget from "../../../../../common/grid/widgets/BookmarkWidget"
import ShortcutWidget from "../../../../../common/grid/widgets/ShortcutWidget"

import {
    getFilteredBookmarksByTitle,
    FilteredBookmarks,
} from "../../../../../bookmarks/selectors"
import {
    getFilteredShortcutsByTitle,
    FilteredShortcuts,
} from "../../../../../shortcuts/selectors"

import NavigationTab from "../NavigationTab"
import { IGridTile } from "../../../../../../models"

interface OwnProps {
    nothingFoundLabel: string
    onNavigate: () => void
}

interface StateProps extends FilteredBookmarks, FilteredShortcuts {
    isLoading: boolean
    tiles: IGridTile[]
}

type Props = OwnProps & StateProps

export const BookmarksAndShortcuts = ({
    filteredBookmarks,
    filteredShortcuts,
    isLoading,
    nothingFoundLabel,
    onNavigate,
    tiles,
}: Props): JSX.Element => {
    const bookmarkIds = filteredBookmarks.map((bookmark) => bookmark.bookmarkId)
    const shortcutIds = filteredShortcuts.map((shortcut) => shortcut.id)

    return (
        <NavigationTab
            isLoading={isLoading}
            hasContent={
                filteredBookmarks.length > 0 || filteredShortcuts.length > 0
            }
            nothingFoundLabel={nothingFoundLabel}
            data-ft-id="navigationPanelBookmarks"
            arePlaceholdersWidgets={true}
        >
            <div className="is-inverted">
                {tiles.map((tile, index) => {
                    // we use the welcome page grid order for the bookmarks and the shorcuts
                    // using index as key ensures that upon reordering the grid, this list will be rerendered with the new order too
                    if (tile.type === "Bookmark") {
                        const bookmarkIndex = bookmarkIds.indexOf(
                            tile.bookmarkId,
                        )
                        if (bookmarkIndex >= 0) {
                            return (
                                <BookmarkWidget
                                    bookmark={filteredBookmarks[bookmarkIndex]}
                                    key={index}
                                    onNavigate={onNavigate}
                                />
                            )
                        }
                    } else if (tile.type === "Shortcut") {
                        const shortcutIndex = shortcutIds.indexOf(
                            tile.shortcutId,
                        )

                        if (shortcutIndex >= 0) {
                            return (
                                <ShortcutWidget
                                    shortcut={filteredShortcuts[shortcutIndex]}
                                    key={index}
                                    onNavigate={onNavigate}
                                />
                            )
                        }
                    }
                })}
            </div>
        </NavigationTab>
    )
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    isLoading:
        state.bookmarks.isLoading ||
        state.shortcuts.isLoading ||
        !state.welcomePage.grid.id,
    ...getFilteredBookmarksByTitle(state.bookmarks),
    ...getFilteredShortcutsByTitle(state.shortcuts),
    tiles: state.welcomePage.grid.tiles,
})

export default connect(mapStateToProps, {})(BookmarksAndShortcuts)
